<template>
 <a href="#" @click="formUrl(params.value)">{{ params.value }}</a>
</template>

<script>
export default {
  name: 'CellRendererIPAddressAction',
   methods: {
       formUrl(userIP){
           window.open("https://mxtoolbox.com/SuperTool.aspx?action=arin%3a"+userIP+"&run=toolpage", "_blank"); 
       }
   },
}
</script>


